<div class="footer m-t-sm">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-top-large min-h">
      <strong>&copy; 1999-{{todaysDate | date: 'y'}}</strong> <i class="fa fa-lightbulb-o blue-bulb adj-buld" pTooltip="App Version: {{verWeb}}" tooltipPosition="top"></i>Industry Intelligence Inc. All
      rights reserved.
    </div>
  </div>
</div>